module.exports = __webpack_public_path__ + "img/operate4.3e07e1cf.png";